import type { FreeTextJSONSchema } from "../../../types";

export function getIsFreeTextBlock(
  jsonSchema: JSONSchema,
  uiSchema: UISchema,
): jsonSchema is FreeTextJSONSchema {
  return (
    jsonSchema?.type === "string" &&
    // should not have title
    jsonSchema.title === undefined &&
    uiSchema &&
    uiSchema["ui:widget"] === "textarea"
  );
}
